module.exports = __webpack_public_path__ + "img/mylanta_maximum_strength_liquid_smooth_creamy_taste.1ceaeab6.jpg";